module.exports = __webpack_public_path__ + "media/พูดได้ไหม.d6a12f53.mp3";